export default function ProductsSection() {
  return (
    <section className="w-full bg-white py-10 flex flex-col items-center">
      <div className="max-w-6xl mx-auto px-6 w-full flex justify-center">
        <img
          src="https://nutravitltd.co.uk/images/home_06.jpg"
          alt="Vitatec Nutrition Product Range"
          className="max-w-full h-auto object-contain"
        />
      </div>
    </section>
  );
}
